import React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';

import { selectUIMessages, selectUIProgress } from '../ui/ui.helpers.js';
import { IndexContext } from './context';

import {
  About, AllInclude, Contact, Demos, Download, FAQ,
  Hero, HowItWorks, IndScreen, InfoIcons, Banners,
  NeedMore, Pricing, Search, UseApps, VideoPopup,
  Video
} from './components'

import {
  howItWorksSec, howItWorksVideo, heroSection, indexDemo,
  contactSection, useAppsInfo, iconsSection, banner,
  aboutSection, faq, infoIconsList, appScreens, webScreens, downloadSection
} from './constants/holdshort'


class IndexScreen extends React.Component {
  constructor(props) {
    super(props);

    const initialState = window.serverData ? window.serverData.initialStateData : {};
    const { data } = initialState;

    const pricingSection = Object
      .keys(data.allPlans)
      .map((key) => data.allPlans[key])

    this.state = {
      pricingSection,
      initialState,
    }
  }

  state = {
    initialState: {},
    pricingSection: {},
    isVideoPopupOpen: false
  };

  handleVideoPopup = isVideoPopupOpen =>
    this.setState({ isVideoPopupOpen });

  render() {
    const { isVideoPopupOpen, initialState, pricingSection } = this.state;
    const { isLogged, action, data, user, uri, request } = initialState;
    const { isTrialAvailable } = data;

    return (
      <IndexContext.Provider value={{
        baseUrl: uri,
        isLogged,
      }}>
        <div className="index-wrapper">
          <Hero request={request} heroSection={heroSection} />
          <Search userZip={user.userZip} />
          <section className="index-demo container-block" id="how-it-works">
            <HowItWorks howItWorksSec={howItWorksSec} />
            <Video howItWorksVideo={howItWorksVideo} handleVideoPopup={this.handleVideoPopup} />
          </section>
          <InfoIcons infoIconsList={infoIconsList} />
          <Banners banner={banner} />
          <IndScreen appScreens={appScreens} webScreens={webScreens}
            tabLabels={{
              label1: 'App screens',
              label2: 'Web site screen'
            }}
          />
          <Download downloadSection={downloadSection} />
          <About aboutSection={aboutSection} />
          <Pricing pricingSection={pricingSection} action={action}
            isTrialAvailable={isTrialAvailable}
          />
          <NeedMore/>
          <AllInclude iconsSection={iconsSection} />
          <UseApps useAppsInfo={useAppsInfo} />
          <Demos indexDemo={indexDemo} />
          <FAQ faq={faq} />
          <Contact contactSection={contactSection} />

          {isVideoPopupOpen && <VideoPopup handleVideoPopup={this.handleVideoPopup} />}
        </div>
      </IndexContext.Provider>
    );
  }
}

const progressSelector = selectUIProgress();
const messagesSelector = selectUIMessages();

const mapStateToProps = state => ({
  URL: state.URL,
  progress: progressSelector(state),
  messages: messagesSelector(state),
  accessgroups: state.accessgroups
});

export default connect(
  mapStateToProps,
  {...formActions},
  mergeActionsToProps
)(IndexScreen);